export const paymentMethodTypes = [
  { name: "withdrawals", title: "Withdrawals" },
  { name: "deposits", title: "User deposits" },
];
